import { HTTP_GET, HTTP_POST, HTTP_PUT, WebApiRequest } from "tools/webservice";
import { Ref } from "react";
import { PhoenixRuleDetailEdit, PromoteFormData, RuleRecommendationListItem } from "interfaces/Mueller.Business.Models";
import { RulesetDefinition, FormDefinitionAccountSettings, FormDefinition, FormDefinitionValidateResponse, CreateRulesetDefinitionRequest, FormDefinitionCopyRequest, FormDesignerPromoteResponse } from "interfaces/Phoenix.FormsDesigner.Models";

export const getRulesRecommendationsList = (
  successCallback: (data: RuleRecommendationListItem[]) => void,
  mountedRef: Ref<boolean>
) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: "/phoenixforms-rules-list/rules",
    successCallback,
    mountedRef,
  });

export const createRulesetDefinition = (
  request: CreateRulesetDefinitionRequest,
  successCallback: (data: RulesetDefinition) => void,
  mountedRef: Ref<boolean>
) =>
  WebApiRequest({
    method: HTTP_POST,
    payload: request,
    endpoint: "/phoenixforms-rules-list/rules",
    successCallback,
    mountedRef,
  });

export const copyRulesetDefinition = (
  rulesetDefinitionId: string,
  request: FormDefinitionCopyRequest,
  successCallback: (data: RulesetDefinition) => void,
  mountedRef: Ref<boolean>
) =>
  WebApiRequest({
    method: HTTP_POST,
    payload: request,
    endpoint: `/phoenixforms-rules-list/rules/${rulesetDefinitionId}/copy`,
    successCallback,
    mountedRef,
  });

export const getRulesetDefinition = (
  rulesetDefinitionId: string,
  successCallback: (data: RulesetDefinition) => void,
  errorCallback: () => void,
  mountedRef: Ref<boolean>
) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/phoenixforms-rules-list/rules/${rulesetDefinitionId}/definition`,
    successCallback,
    errorCallback,
    mountedRef,
  });

export const getRulesetSettings = (
  successCallback: (data: FormDefinitionAccountSettings) => void,
  errorCallback: () => void,
  mountedRef: Ref<boolean>
) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/phoenixforms-rules-list/rules/settings`,
    successCallback,
    errorCallback,
    mountedRef,
  });

export const getLinkedFormDefinition = (
  linkedFormDefinitionId: string,
  successCallback: (data: FormDefinition) => void,
  errorCallback: () => void,
  mountedRef: Ref<boolean>
) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/phoenixforms-rules-list/rules/${linkedFormDefinitionId}/linked-form`,
    successCallback,
    errorCallback,
    mountedRef,
  });

export const updateRulesetDefinition = (
  rulesetDefinitionId: string,
  rulesetDef: RulesetDefinition,
  successCallback: () => void,
  errorCallback: () => void,
  mountedRef: Ref<boolean>
) =>
  WebApiRequest({
    method: HTTP_PUT,
    payload: rulesetDef,
    endpoint: `/phoenixforms-rules-list/rules/${rulesetDefinitionId}`,
    successCallback,
    errorCallback,
    mountedRef,
  });

export const saveRulesetDetail = (
  rulesetDefinitionId: string,
  rulesetData: PhoenixRuleDetailEdit,
  successCallback,
  errorCallback,
  mountedRef,
) =>
  WebApiRequest({
    method: HTTP_POST,
    payload: rulesetData,
    endpoint: `/phoenixforms-rules-list/rules/${rulesetDefinitionId}/detail`,
    successCallback,
    errorCallback,
    mountedRef,
  });

export const validateRulesetDefinition = (
  rulesetDefinitionId: string,
  successCallback: (data: FormDefinitionValidateResponse) => void,
  errorCallback: () => void,
  mountedRef: Ref<boolean>
) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/phoenixforms-rules-list/rules/${rulesetDefinitionId}/validate`,
    successCallback,
    errorCallback,
    mountedRef,
  });

export const getPromoteData = (
  rulesetDefinitionId: string,
  successCallback: (data: PromoteFormData) => void,
  errorCallback: () => void,
  mountedRef: Ref<boolean>
) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/phoenixforms-rules-list/rules/${rulesetDefinitionId}/promote-data`,
    successCallback,
    errorCallback,
    mountedRef,
  });

export const promoteRuleset = (
  rulesetDefinitionId: string,
  successCallback: (data: FormDesignerPromoteResponse) => void,
  errorCallback: () => void,
  mountedRef: Ref<boolean>
) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: `/phoenixforms-rules-list/rules/${rulesetDefinitionId}/promote`,
    successCallback,
    errorCallback,
    mountedRef,
  });
